module.exports = __webpack_public_path__ + "static/edge-c2940ecd78d2504eb5b0d30e2928df41.svg";